import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { BreadcrumbsModule, BreadcrumbsService } from '@shared/modules/page-settings';
import { WrapperComponent, RouterOutletComponent } from '@shared/ui/components';
import { IdleTimeoutService, WINDOW } from '@shared/utils';
import { MenuItem } from '@openng/optimus-ui/api';
import { Breadcrumb } from '@openng/optimus-ui/breadcrumb';
import { filter, map } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { FooterComponent } from '../../components/footer/footer.component';
import { HeaderComponent } from '../../components/header/header.component';
import { NavbarComponent } from '../../components/navbar/navbar.component';

@Component({
  selector: 'reza-default-layout',
  templateUrl: './default-layout.component.html',
  imports: [
    FooterComponent,
    HeaderComponent,
    NavbarComponent,
    RouterOutletComponent,
    CommonModule,
    BreadcrumbsModule,
    RouterModule,
    WrapperComponent,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class DefaultLayoutComponent implements OnInit {
  private breadcrumbsService = inject(BreadcrumbsService);
  readonly windowRef = inject<Window>(WINDOW);
  private router = inject(Router);
  private idleTimeoutService = inject(IdleTimeoutService);
  private activatedRoute = inject(ActivatedRoute);

  hideBreadcrumb = true;
  hideNavbar = true;
  publicFooter = false;

  breadcrumbs$ = this.breadcrumbsService.breadcrumbs$.pipe(
    map((breadcrumbs: Breadcrumb[]) => {
      return [
        {
          icon: 'pi pi-home',
          routerLink: `/`,
          label: 'home',
        } as MenuItem,
        ...breadcrumbs,
      ];
    })
  );

  ngOnInit(): void {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.updateRouteAttributes();
    });

    this.breadcrumbsService.init();
    this.updateRouteAttributes();
  }

  private updateRouteAttributes(): void {
    let route = this.activatedRoute.firstChild;
    while (route?.firstChild) {
      route = route.firstChild;
    }

    this.hideBreadcrumb = route?.snapshot.data['hideBreadcrumb'] === true;
    this.hideNavbar = route?.snapshot.data['hideNavbar'] === true;
    this.publicFooter = route?.snapshot.data['publicFooter'] === true;
  }

  // Debugovani session timer dialogu, prihodit tlacitko nekam, ktere pusti tuhle funkci a lets go
  startCountdown() {
    this.idleTimeoutService.startInactivityTimer();
  }
}
